import { render, staticRenderFns } from "./ReferenceImage.vue?vue&type=template&id=6b20c471&scoped=true"
import script from "./ReferenceImage.vue?vue&type=script&lang=js"
export * from "./ReferenceImage.vue?vue&type=script&lang=js"
import style0 from "./ReferenceImage.vue?vue&type=style&index=0&id=6b20c471&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b20c471",
  null
  
)

export default component.exports